export class GetServicePage {
    static readonly type = '[ServicePages] GetServicePage';

    constructor(public url: string) {}
}
